import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';

import { IRadioButtonField } from '@shared/interfaces';

@Component({
  selector: 'app-radio-section',
  templateUrl: './radio-section.component.html',
  styleUrls: ['./radio-section.component.scss'],
  standalone: false,
})
export class RadioSectionComponent implements OnInit {
  @Input() control!: FormControl;
  @Input() field!: IRadioButtonField;

  @Output() valueChange = new EventEmitter<string>();

  ngOnInit() {
    // Add required validator if needed
    if (this.field.isRequired) {
      this.control.setValidators([Validators.required]);
      this.control.updateValueAndValidity();
    }

    // Watch for changes in the control
    this.control.valueChanges.subscribe((val) => {
      this.valueChange.emit(val);
    });
  }
}
